var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list', {
    staticClass: "item-panel",
    attrs: {
      "data-title": "Tables",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "px-0"
  }, [_c('h2', {
    staticClass: "black--text"
  }, [_vm._v(" Tables ")]), _c('v-spacer'), _c('div', {
    staticClass: "actions mr-2 pr-3"
  }, [_c('download-dialog', {
    ref: "downloader",
    attrs: {
      "selection": _vm.selection,
      "workspace": _vm.workspace,
      "download-type": "table"
    },
    on: {
      "downloaded": _vm.cleanup
    }
  }), _c('delete-table-dialog', {
    ref: "deleter",
    attrs: {
      "selection": _vm.selection,
      "workspace": _vm.workspace
    },
    on: {
      "closed": _vm.cleanup
    }
  })], 1), _c('table-dialog', {
    attrs: {
      "workspace": _vm.workspace
    },
    on: {
      "success": _vm.cleanup
    }
  })], 1), _c('v-divider'), _vm.loading ? _c('div', [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  })], 1) : _vm.items.length === 0 ? _c('div', {
    staticClass: "ws-detail-empty-list"
  }, [_c('v-icon', {
    attrs: {
      "color": "blue lighten-1"
    }
  }, [_vm._v(" mdi-information ")]), _vm._v(" There's nothing here yet... ")], 1) : [_c('v-list-item-group', {
    attrs: {
      "color": "primary"
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('v-hover', {
      key: item.id,
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref) {
          var hover = _ref.hover;
          return _c('v-list-item', {
            attrs: {
              "active-class": "grey lighten-4",
              "ripple": "",
              "to": "/workspaces/".concat(_vm.workspace, "/table/").concat(item.name),
              "three-line": ""
            }
          }, [_c('v-list-item-action', {
            on: {
              "click": function click($event) {
                $event.preventDefault();
              }
            }
          }, [!hover && !_vm.checkbox[item.name] ? _c('v-icon', {
            staticClass: "item-icon"
          }, [_vm._v(" mdi-table ")]) : _c('v-checkbox', {
            staticClass: "ws-detail-checkbox",
            model: {
              value: _vm.checkbox[item.name],
              callback: function callback($$v) {
                _vm.$set(_vm.checkbox, item.name, $$v);
              },
              expression: "checkbox[item.name]"
            }
          })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.name))]), _c('v-list-item-subtitle', [_vm._v("Created: " + _vm._s(new Date(item.created).toISOString().split('T')[0]))])], 1), _c('v-list-item-action', [_c('v-btn', {
            staticClass: "mt-3",
            attrs: {
              "disabled": !hover,
              "color": "primary",
              "href": "".concat(_vm.upsetUrl, "/?workspace=").concat(_vm.workspace, "&table=").concat(item.name),
              "target": "_blank",
              "depressed": "",
              "small": ""
            },
            on: {
              "click": function click($event) {
                $event.stopPropagation();
              }
            }
          }, [_vm._v(" Visualize in Upset ")])], 1)], 1);
        }
      }], null, true)
    });
  }), 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }